import { render, staticRenderFns } from "./HealthEducationList.vue?vue&type=template&id=6b3b3f0b&scoped=true"
import script from "./HealthEducationList.vue?vue&type=script&lang=js"
export * from "./HealthEducationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b3f0b",
  null
  
)

export default component.exports